export const GET_INVENTORY_INITIAL_DATA = 'GET_INVENTORY_INITIAL_DATA';
export const GET_INVENTORY_INITIAL_DATA_SUCCESS = `${GET_INVENTORY_INITIAL_DATA}/SUCCESS`;
export const GET_INVENTORY_INITIAL_DATA_FAILURE = `${GET_INVENTORY_INITIAL_DATA}/FAILURE`;

export const GET_INVENTORY = 'GET_INVENTORY';
export const GET_INVENTORY_SUCCESS = `${GET_INVENTORY}/SUCCESS`;
export const GET_INVENTORY_FAILURE = `${GET_INVENTORY}/FAILURE`;

export const GET_DELETED_INVENTORY = 'GET_DELETED_INVENTORY';
export const GET_DELETED_INVENTORY_SUCCESS = `${GET_DELETED_INVENTORY}/SUCCESS`;
export const GET_DELETED_INVENTORY_FAILURE = `${GET_DELETED_INVENTORY}/FAILURE`;

export const GET_INVENTORY_TITLE_DETAILS = 'GET_INVENTORY_TITLE_DETAILS';
export const GET_INVENTORY_TITLE_DETAILS_SUCCESS = `${GET_INVENTORY_TITLE_DETAILS}/SUCCESS`;
export const GET_INVENTORY_TITLE_DETAILS_FAILURE = `${GET_INVENTORY_TITLE_DETAILS}/FAILURE`;

export const SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL =
  'SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL';
export const SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS = `${SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL}/SUCCESS`;
export const SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_FAILURE = `${SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL}/FAILURE`;

export const DELETE_INVENTORY = 'DELETE_INVENTORY';
export const DELETE_INVENTORY_SUCCESS = `${DELETE_INVENTORY}/SUCCESS`;
export const DELETE_INVENTORY_FAILURE = `${DELETE_INVENTORY}/FAILURE`;

export const IS_PRECISE_LOCATION_SET = 'IS_PRECISE_LOCATION_SET';
export const IS_PRECISE_LOCATION_SET_SUCCESS = `${IS_PRECISE_LOCATION_SET}/SUCCESS`;
export const IS_PRECISE_LOCATION_SET_FAILURE = `${IS_PRECISE_LOCATION_SET}/FAILURE`;

export const GET_NON_CHECKED_CHEMICALS = 'GET_NON_CHECKED_CHEMICALS';
export const GET_NON_CHECKED_CHEMICALS_SUCCESS = `${GET_NON_CHECKED_CHEMICALS}/SUCCESS`;
export const GET_NON_CHECKED_CHEMICALS_FAILURE = `${GET_NON_CHECKED_CHEMICALS}/FAILURE`;

export const MARK_AS_CHECKED = 'MARK_AS_CHECKED';
export const MARK_AS_CHECKED_SUCCESS = `${MARK_AS_CHECKED}/SUCCESS`;
export const MARK_AS_CHECKED_FAILURE = `${MARK_AS_CHECKED}/FAILURE`;

export const CREATE_INVENTORIES_QR_STICKERS_PDF = 'CREATE_INVENTORIES_QR_STICKERS_PDF';
export const CREATE_INVENTORIES_QR_STICKERS_PDF_SUCCESS = `${CREATE_INVENTORIES_QR_STICKERS_PDF}/SUCCESS`;
export const CREATE_INVENTORIES_QR_STICKERS_PDF_FAILURE = `${CREATE_INVENTORIES_QR_STICKERS_PDF}/FAILURE`;

export default {
  GET_INVENTORY_INITIAL_DATA,
  GET_INVENTORY_INITIAL_DATA_SUCCESS,
  GET_INVENTORY_INITIAL_DATA_FAILURE,

  GET_INVENTORY,
  GET_INVENTORY_SUCCESS,
  GET_INVENTORY_FAILURE,

  GET_DELETED_INVENTORY,
  GET_DELETED_INVENTORY_SUCCESS,
  GET_DELETED_INVENTORY_FAILURE,

  GET_INVENTORY_TITLE_DETAILS,
  GET_INVENTORY_TITLE_DETAILS_SUCCESS,
  GET_INVENTORY_TITLE_DETAILS_FAILURE,

  SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL,
  SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS,
  SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_FAILURE,

  DELETE_INVENTORY,
  DELETE_INVENTORY_SUCCESS,
  DELETE_INVENTORY_FAILURE,

  IS_PRECISE_LOCATION_SET,
  IS_PRECISE_LOCATION_SET_SUCCESS,
  IS_PRECISE_LOCATION_SET_FAILURE,

  GET_NON_CHECKED_CHEMICALS,
  GET_NON_CHECKED_CHEMICALS_SUCCESS,
  GET_NON_CHECKED_CHEMICALS_FAILURE,

  MARK_AS_CHECKED,
  MARK_AS_CHECKED_SUCCESS,
  MARK_AS_CHECKED_FAILURE,

  CREATE_INVENTORIES_QR_STICKERS_PDF,
  CREATE_INVENTORIES_QR_STICKERS_PDF_SUCCESS,
  CREATE_INVENTORIES_QR_STICKERS_PDF_FAILURE
};
